// extracted by mini-css-extract-plugin
export default {"wrapper":"qw-z","viewport":"rw-z","container":"sw-z","slide":"tw-z"};